export default __webpack_public_path__ + "static/media/chevron-fill.a81165a3.svg";